import { render, staticRenderFns } from "./MoneyInputConfig.vue?vue&type=template&id=6886da1c&scoped=true"
import script from "./MoneyInputConfig.vue?vue&type=script&lang=js"
export * from "./MoneyInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886da1c",
  null
  
)

export default component.exports